// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PAGE {
  page-break-after: always;
  width: 190mm;
}

table {
  table-layout: fixed;
  border-collapse: collapse;
  border-spacing: 0;
  border-style: solid;
  border-color: #000;
  border: 0;
  font-size: 7pt;
  font-family: "LiberationSerif", serif;
  line-height: 1;
}

table td {
  border-color: #000;
}

.bd {
  border: 1px solid #000;
}

.line {
  padding-top: 3pt;
}

.line2 {
  padding-top: 0;
}

label {
  font-size: 10pt;
  line-height: 1.4;
  float: left;
  margin-right: 4px;
}

label.right {
  float: right;
  margin: 0 0 0 4px;
}

span.resizer, span.us, span.us-ov {
  text-transform: uppercase;
  font-size: 9pt;
  font-family: "LiberationSerif", serif;
}

span.us, span.us-ov {
  clear: both;
  border-bottom: 1px solid #000;
  padding-bottom: 1px;
  display: block;
  height: 11pt;
  line-height: 12pt;
  overflow: hidden;
}

span.us-ov {
  clear: none;
}

.subtext {
  text-align: center;
  padding-top: 3px;
}

.fl-right {
  float: right;
  margin-left: 8px;
}

.label-left {
  font-size: 10pt;
  line-height: 1.4;
  float: right;
  margin-left: 4px;
}

.letter-n {
  font-size: 7pt;
  line-height: 1;
}

.cell-txt {
  display: block;
  font-size: 9pt;
  padding: 2px 2px 6px;
}

.fixed-h46 {
  display: block;
  height: 38px;
  overflow: hidden;
  padding: 2px 2px 6px;
}

.printPhotoBorder {
  display: table;
  width: 128px;
  height: 171px;
}

.printPhotoIner {
  display: table-cell;
  vertical-align: middle;
}

.printPhoto {
  display: block;
  max-width: 128px;
  max-height: 171px;
}

.statement_number {
  padding-top: 10px;
  font-size: 16px;
  position: relative;
}

.statement_left {
  position: absolute;
  left: 0;
  bottom: 0;
}

.statement_center {
  position: relative;
  left: 0;
  right: 0;
  text-align: center;
  font-weight: bold;
}

.statement_right {
  position: absolute;
  right: 0;
  bottom: 0;
}`, "",{"version":3,"sources":["webpack://./src/webid/4.0/model/print-web/view/adult-request-form-v1/adult-request-form-v1.component.scss"],"names":[],"mappings":"AAAA;EACI,wBAAA;EACA,YAAA;AACJ;;AACA;EACI,mBAAA;EACA,yBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,cAAA;EACA,qCAAA;EACA,cAAA;AAEJ;;AAAA;EACI,kBAAA;AAGJ;;AADA;EACI,sBAAA;AAIJ;;AAFA;EACI,gBAAA;AAKJ;;AAHA;EACI,cAAA;AAMJ;;AAJA;EACI,eAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;AAOJ;;AALA;EACI,YAAA;EACA,iBAAA;AAQJ;;AANA;EACI,yBAAA;EACA,cAAA;EACA,qCAAA;AASJ;;AAPA;EACI,WAAA;EACA,6BAAA;EACA,mBAAA;EACA,cAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;AAUJ;;AARA;EACI,WAAA;AAWJ;;AATA;EACI,kBAAA;EACA,gBAAA;AAYJ;;AAVA;EACI,YAAA;EACA,gBAAA;AAaJ;;AAXA;EACI,eAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;AAcJ;;AAZA;EACI,cAAA;EACA,cAAA;AAeJ;;AAbA;EACI,cAAA;EACA,cAAA;EACA,oBAAA;AAgBJ;;AAdA;EACI,cAAA;EACA,YAAA;EACA,gBAAA;EACA,oBAAA;AAiBJ;;AAfA;EACI,cAAA;EACA,YAAA;EACA,aAAA;AAkBJ;;AAhBA;EACI,mBAAA;EACA,sBAAA;AAmBJ;;AAjBA;EACI,cAAA;EACA,gBAAA;EACA,iBAAA;AAoBJ;;AAjBA;EACI,iBAAA;EACA,eAAA;EACA,kBAAA;AAoBJ;;AAjBA;EACI,kBAAA;EACA,OAAA;EACA,SAAA;AAoBJ;;AAjBA;EACI,kBAAA;EACA,OAAA;EACA,QAAA;EACA,kBAAA;EACA,iBAAA;AAoBJ;;AAjBA;EACI,kBAAA;EACA,QAAA;EACA,SAAA;AAoBJ","sourcesContent":[".PAGE {\n    page-break-after: always;\n    width: 190mm;\n}\ntable {\n    table-layout: fixed;\n    border-collapse: collapse;\n    border-spacing: 0;\n    border-style: solid;\n    border-color: #000;\n    border: 0;\n    font-size: 7pt;\n    font-family: \"LiberationSerif\", serif;\n    line-height: 1;\n}\ntable td {\n    border-color: #000;\n}\n.bd {\n    border: 1px solid #000;\n}\n.line {\n    padding-top: 3pt;\n}\n.line2 {\n    padding-top: 0;\n}\nlabel {\n    font-size: 10pt;\n    line-height: 1.4;\n    float: left;\n    margin-right: 4px;\n}\nlabel.right {\n    float: right;\n    margin: 0 0 0 4px;\n}\nspan.resizer, span.us, span.us-ov {\n    text-transform: uppercase;\n    font-size: 9pt;\n    font-family: \"LiberationSerif\", serif;\n}\nspan.us, span.us-ov {\n    clear: both;\n    border-bottom: 1px solid #000;\n    padding-bottom: 1px;\n    display: block;\n    height: 11pt;\n    line-height: 12pt;\n    overflow: hidden;\n}\nspan.us-ov {\n    clear: none;\n}\n.subtext {\n    text-align: center;\n    padding-top:3px;\n}\n.fl-right {\n    float: right;\n    margin-left: 8px;\n}\n.label-left {\n    font-size: 10pt;\n    line-height: 1.4;\n    float: right;\n    margin-left: 4px;\n}\n.letter-n {\n    font-size: 7pt;\n    line-height: 1;\n}\n.cell-txt {\n    display: block;\n    font-size: 9pt;\n    padding: 2px 2px 6px;\n}\n.fixed-h46 {\n    display: block;\n    height: 38px;\n    overflow: hidden;\n    padding: 2px 2px 6px;\n}\n.printPhotoBorder {\n    display: table;\n    width: 128px;\n    height: 171px;\n}\n.printPhotoIner {\n    display: table-cell;\n    vertical-align: middle;\n}\n.printPhoto {\n    display: block;\n    max-width: 128px;\n    max-height: 171px;\n}\n\n.statement_number {\n    padding-top: 10px;\n    font-size: 16px;\n    position: relative;\n}\n\n.statement_left {\n    position: absolute;\n    left: 0;\n    bottom: 0;\n}\n\n.statement_center {\n    position: relative;\n    left: 0;\n    right: 0;\n    text-align: center;\n    font-weight: bold;\n}\n\n.statement_right {\n    position: absolute;\n    right: 0;\n    bottom: 0;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
